module.exports = __webpack_public_path__ + "static/media/home-banner.e1f1d50a.png";